import type {
    FiltroNotificacoes,
    NotificacaoAgendadaModel,
    NotificacaoEnviadaModel,
} from "../models/verNotificacoesFornecedorModel"

export enum VerNotificacoesFornecedorActionsTypes {
    CARREGAR_ENVIADAS = "CARREGAR_ENVIADAS",
    CARREGAR_AGENDADAS = "CARREGAR_AGENDADAS",
    REMOVER_AGENDADA = "REMOVER_AGENDADA",
    SET_FILTRO = "SET_FILTRO",
}

type CarregarEnviadasAction = {
    type: VerNotificacoesFornecedorActionsTypes.CARREGAR_ENVIADAS
    payload: NotificacaoEnviadaModel[]
}

type CarregarAgendadasAction = {
    type: VerNotificacoesFornecedorActionsTypes.CARREGAR_AGENDADAS
    payload: NotificacaoAgendadaModel[]
}

type RemoverAgendadaAction = {
    type: VerNotificacoesFornecedorActionsTypes.REMOVER_AGENDADA
    payload: { id: number }
}

type SetFiltroAction = {
    type: VerNotificacoesFornecedorActionsTypes.SET_FILTRO
    payload: Partial<FiltroNotificacoes>
}

export type VerNotificacoesFornecedorActions =
    | CarregarEnviadasAction
    | CarregarAgendadasAction
    | RemoverAgendadaAction
    | SetFiltroAction
